import React from 'react'
import styles from './ColorPicker.scss'
import { Popover } from 'common/styleguide/Popover'
import { CustomPicker } from 'react-color'
import { Saturation, Hue, EditableInput } from 'react-color/lib/components/common'

class _ColorPicker extends React.PureComponent {
  resetClicked = (e) => {
    e.preventDefault()
    const { defaultColor, onChange } = this.props
    defaultColor && onChange({ hex: defaultColor })
  }

  render () {
    const { target, defaultColor, onRequestClose, ...colorProps } = this.props

    const popoverProps = {
      onRequestClose,
      target
    }

    const inputStyles = {
      input: {
        width: '100%'
      }
    }

    return (
      <Popover
        container={window.body}
        {...popoverProps}>
        <div className={styles.ColorPicker}>
          <div className={styles.colorControls}>
            <div className={styles.Saturation}>
              <Saturation
                {...colorProps} />
            </div>
            <div className={styles.Hue}>
              <Hue
                direction='vertical'
                {...colorProps} />
            </div>
          </div>
          <div className={styles.colorFields}>
            <div className={styles.input}>
              <EditableInput
                style={inputStyles}
                value={colorProps.hex}
                onChange={colorProps.onChange} />
              {defaultColor &&
                <div className={styles.reset}>
                  <a onClick={this.resetClicked}>Reset</a>
                </div>}
            </div>
          </div>
        </div>
      </Popover>
    )
  }
}

export const ColorPicker = CustomPicker(_ColorPicker)
